<div class="switch-container" [ngClass]="classes">
    <div class="label">
        <app-label [for]="name" [label]="label" *ngIf="showLabel"></app-label>
    </div>
    <label class="switch">
        <input (blur)="onTouched()" (ngModelChange)="onChange($event)" [(ngModel)]="value" [checked]="value" [id]="name"
            [name]="name" type="checkbox" />
        <span class="slider round"></span>
    </label>
</div>
<span class="error" *ngIf="showError">{{ error }}</span>
